import { useState } from 'react';
import requestImportConversions from '../Utils/requestImportConversions';

const FILE_EXTENSION = '.mrpreq';

export default function useLoadRequest(modelType) {
    const [importing, setImporting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
      
    const onChange = (e1) => { 
      setImporting(true);
      const filename = e1.target.files.item(0).name;
      const reader = new FileReader();

      // get what should be the extension off of the end of the file using the negative index
      if (filename.toLowerCase().slice(-1 * FILE_EXTENSION.length) !== FILE_EXTENSION) {
          setError(`File must have extension type ${FILE_EXTENSION}`);
          setImporting(false);
          setSuccess(false);
      } else {
        reader.onload = (e2) => {
          try {
            const loadedRequest = JSON.parse(e2.target.result);
            if (loadedRequest.pricer !== modelType) {
              throw `Pricer type error: File is for pricer ${loadedRequest.pricer} not for ${modelType}. Navigate to the ${loadedRequest.pricer} page before loading this claim.`;
            }
            const modelUpper = modelType.toUpperCase();
            const pagePricerVersion = process.env[`REACT_APP_${modelUpper}_VERSION`];
            if (loadedRequest.pricerVersion !== pagePricerVersion){
              const requestConversions = requestImportConversions[modelUpper];
              if (!requestConversions || !requestConversions.some(rc => rc.from === loadedRequest.pricerVersion && rc.to === pagePricerVersion)) {
                throw `Pricer version error: File is from version ${loadedRequest.pricerVersion} of the ${loadedRequest.pricer} pricer`;
              } 
              
              const converter = requestConversions.find(rc => rc.from === loadedRequest.pricerVersion && rc.to === pagePricerVersion);
              setResult(converter.migration(loadedRequest));
            } else {
              setResult(loadedRequest);
            }

            setSuccess(true);
          } catch (error) {
            if (error instanceof SyntaxError) {
              setError("File syntax error: File is not in a valid format.");
            } else if (typeof error === "string") {
              setError(error);
            } else {
              setError(`File load error: ${error.message}`);
            }
          } finally {
            setImporting(false);
          }
        };

        try {
          reader.readAsText(e1.target.files[0]);
        } catch(e) {
          setError(e);
          setImporting(false);
        }
      }
    };

    const executeReset = () => {
      setImporting(false);
      setSuccess(false);
      setError(null);
      setResult(null);
    };


    return [importing, success, error, result, executeReset, onChange];
};